import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class StudentCounsellingReportService {
  jwt='eyJhbGciOiJIUzI1NiJ9.eyJ0b2tlblJlZnJlc2hLZXkiOiJCU3NTR2RGaDVCZE9QeVNpM25kZXU0JTJGZEtnSG1ZcEp5bjY4RkMzaTglMkZIVSUzRCIsImNhbXB1c0lkIjoxNzksInBheXJvbGxJZCI6IkhZRDEwMzEzNSIsInVzZXJOYW1lIjoiQ0ggU0FUWUFOQVJBWUFOQSIsImV4cCI6MTc1MTAyODc4MiwidXNlcklkIjoiSFlEMTAzMTM1IiwiaWF0IjoxNzUwOTQyMzgyLCJ1bmlxdWVJZCI6Mjg0ODYsImp0aSI6IjlmNWNkNDViLWU0MTQtNGU0Ny05MTRmLTQ5MmVmYTljYzRiYyJ9.1ukP0XQlpuxkdrbbTEpcGXLfjInGRKnE-2Ey_KCljFo';
  data: any;
  private baseUrl = '/employee/api/jwtV2';
  constructor(private http: HttpClient, public baseURL: BasemodelService) { }

  getacademic(){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl()+"/employee/api/jwtV2/currentAcademicYear",{headers})
  }
  getstate(){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl()+"/apiV2/common/employeeStates",{headers})

  }
  getcity(stateId:any){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl()+"/apiV2/common/emplStateCities?stateId="+stateId,{headers})

  }
  getcampus(cityId:any){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
return this.http.get(this.baseURL.getCommonUrl()+"/apiV2/common/empCityCampuses?cityId="+cityId,{headers})
  }
  getcounseller (campusid:any){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl()+"/employee/api/jwtV2/counsellors?campusId="+campusid,{headers})
  }
  getreasons(){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this. http.get(this.baseURL.getCommonUrl()+"/employee/api/jwtV2/categoryTypes",{headers})

  }
  getidentifiyiuess(reasonId:any){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    return this.http.get(this.baseURL.getCommonUrl()+"/employee/api/jwtV2/categoryReasons?counselCatId="+reasonId,{headers})
  }
  getCategoryDetails(params: {
    academicYear: string;
    cityId: number;
    campusId?: number;
    counsellorId?: number;
    counselCatId?: any;
  }): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
  
    let url = `${this.baseUrl}/categoryDetails?academicYear=${params.academicYear}&cityId=${params.cityId}`;
  
    if (params.campusId) {
      url += `&campusId=${params.campusId}`;
    }
  
    if (params.counsellorId) {
      url += `&createdBy=${params.counsellorId}`;
    }
  
    if (params.counselCatId) {
      url += `&counselCatId=${params.counselCatId}`;
    }
  
    return this.http.get<any>(this.baseURL.getCommonUrl() + url, { headers });
  }
  getreport(paramsObj: any){
    const headers = new HttpHeaders({
      'Authorization': this.jwt,
    });
    let params = new HttpParams();

    Object.keys(paramsObj).forEach(key => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });
  
    return this.http.get(this.baseURL.getCommonUrl()+'/employee/api/jwtV2/counsellingReport', { params,headers });
  }
  
  
}
